module.exports = __webpack_public_path__ + "static/media/GreenActiveIcon.4201d7da.svg";